module.exports = __webpack_public_path__ + "static/media/PMG Project Proponent (Private) Manual.80d759e4.pdf";